import { ChartContainerProps } from '../components/Charts/ChartContainer';

// Helper function to merge base chart configuration with API data and filter/sort
export const mergeChartConfigWithApiData = (
  baseChartsConfig: ChartContainerProps[],
  graphs: any[] = []
): ChartContainerProps[] => {
  // Create a map of graphs by chartId for easy lookup
  const graphsMap = graphs.reduce((acc, graph) => {
    acc[graph.chartId] = graph;
    return acc;
  }, {} as Record<string, any>);

  return baseChartsConfig
    .map(chart => ({
      ...chart,
      ...(graphsMap[chart.chartId] || {}),
      // Always preserve the title from baseChartsConfig — it may be computed
      // dynamically at render time (e.g. `${flowType} Compliant Organisations`).
      // The DB title is a static label used only by the settings panel.
      title: chart.title,
      // Ensure hideColumnsByIndex is an array if it exists
      hideColumnsByIndex: graphsMap[chart.chartId]?.hideColumnsByIndex 
        ? graphsMap[chart.chartId].hideColumnsByIndex.split(',').map((s: string) => s.trim())
        : chart.hideColumnsByIndex,
    }))
    .filter(chart => {
      const graphConfig = graphsMap[chart.chartId];
      return graphConfig ? graphConfig.isEnabled === 1 : true; // Default to enabled if not found
    })
    .sort((a, b) => {
      const aConfig = graphsMap[a.chartId];
      const bConfig = graphsMap[b.chartId];
      const aOrder = aConfig?.order || 999;
      const bOrder = bConfig?.order || 999;
      return aOrder - bOrder;
    });
};
